import httpClient from '../../client'

import apiRoutes from '../constants'

const completeProposal = async ({id}) => {
  return await httpClient.post(`${apiRoutes.GET_PROPOSALS}/${id}/complete`)
}

export default completeProposal
